<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'home' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Planos Infantis
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-form>
          <v-card>
            <div class="text-start py-2 px-4 text-button">Pesquisa avançada</div>

            <v-divider class="theme--light"></v-divider>
            <v-row class="px-4 mt-4">
              <v-col v-if="permitirRolesParaGestores() >= 0">
                <v-text-field
                  v-model="professor"
                  label="NOME ou CPF Professor"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-space-between mb-6 px-4">
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="disciplinas"
                  :return-object="false"
                  v-model="disciplina"
                  label="Escolha um componente curricular"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="turmas"
                  :return-object="false"
                  v-model="turma"
                  label="Escolha uma turma"
                  item-text="descricao"
                  item-value="descricao"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                  :items="bimestres"
                  :return-object="false"
                  v-model="bimestre"
                  label="Escolha um bimestre"
                  item-text="descricao"
                  item-value="id"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12" class="mb-5">
                <v-btn color="primary" @click="() => limparCampos()" block>Limpar filtros</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-col>

      <v-col cols="12">
        <div class="d-sm-none">
          <v-card v-for="plano in planos" :key="plano.id" class="mb-4" outlined>
            <v-card-text>
              <div class="d-flex justify-space-between">
                <strong>ID:</strong>
                <span>{{ plano.id ? plano.id : "- - -" }}</span>
              </div>
              <div class="d-flex justify-space-between">
                <strong>Professor:</strong>
                <span>{{ plano.gestao_de_aula?.professor?.nome || "Não informado" }}</span>
              </div>
              <div class="d-flex justify-space-between">
                <strong>Turma:</strong>
                <span>{{ plano.gestao_de_aula?.turma?.descricao || "Não informado" }}</span>
              </div>
              <div class="d-flex justify-space-between">
                <strong>Status:</strong>
                <e-situacao-plano-infantil
                  :plano="plano"
                  @update="(e) => carregarDadosAoAtualizarStatus(e)"
                />
              </div>
              <div class="d-flex justify-space-between">
                <strong>Bimestre:</strong>
                <span>{{ plano.bimestre?.descricao || "Não informado" }}</span>
              </div>
              <div class="d-flex justify-space-between">
                <strong>Disciplina:</strong>
                <span>{{ plano.gestao_de_aula?.disciplina?.descricao || "Não informado" }}</span>
              </div>
              <div class="d-flex justify-end mt-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="
                        () =>
                          $router.push({
                            name: 'gestoesDeAulas.planosInfantilVisualizar',
                            params: { id: plano.id },
                          })
                      "
                      x-small
                      class="ml-1"
                      v-bind="attrs"
                      color="orange"
                      v-on="on"
                    >
                      <v-icon small>mdi-note-text-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="() => [visualizarPdf(plano.id), (dialog = true)]"
                      x-small
                      class="ml-1"
                      v-bind="attrs"
                      color="orange"
                      v-on="on"
                    >
                      <v-icon small>mdi-note</v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar Pdf</span>
                </v-tooltip>
              </div>
            </v-card-text>
          </v-card>
        </div>

        <div class="d-none d-sm-block">
          <v-data-table
            :headers="table.headers"
            :items="planos"
            :loading="carregando"
            :items-per-page="15"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:body="{ items }">
              <tbody name="scroll-x-transition" tag="tbody" duration="150">
                <tr v-if="!items || items.length === 0" :key="'empty'">
                  <td
                    :colspan="table.headers && table.headers.length ? table.headers.length : 1"
                    class="text-center pa-4"
                  >
                    <v-alert text color="info">Não há planos cadastrados</v-alert>
                  </td>
                </tr>

                <tr v-else color="primary" v-for="plano in items" :key="plano.id || plano">
                  <td>{{ plano.id ? plano.id : "- - -" }}</td>
                  <td>
                    {{ plano.gestao_de_aula?.professor?.nome }}
                  </td>
                  <td>{{ plano.gestao_de_aula?.turma?.descricao }}</td>
                  <td>
                    <e-situacao-plano-infantil
                      :plano="plano"
                      @update="(e) => carregarDadosAoAtualizarStatus(e)"
                    />
                  </td>
                  <td>{{ plano.bimestre?.descricao }}</td>
                  <td>{{ plano.gestao_de_aula?.disciplina?.descricao }}</td>
                  <td>
                    <div class="d-flex">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="
                              () =>
                                $router.push({
                                  name: 'gestoesDeAulas.planosInfantilVisualizar',
                                  params: { id: plano.id },
                                })
                            "
                            x-small
                            class="ml-1"
                            v-bind="attrs"
                            color="orange"
                            v-on="on"
                          >
                            <v-icon small>mdi-note-text-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Visualizar</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="() => [visualizarPdf(plano.id), (dialog = true)]"
                            x-small
                            class="ml-1"
                            v-bind="attrs"
                            color="orange"
                            v-on="on"
                          >
                            <v-icon small>mdi-note</v-icon>
                          </v-btn>
                        </template>
                        <span>Visualizar Pdf</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="[visualizarPlanoAnexado(plano.id), (dialogInfantil = false)]"
                            x-small
                            class="ml-1"
                            v-bind="attrs"
                            color="orange"
                            v-on="on"
                          >
                            <v-icon small>fa fa-file-pdf-o</v-icon>
                          </v-btn>
                        </template>
                        <span>Visualizar Plano anexado</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>

        <v-snackbar v-model="mostrarMensagem" color="primary">
          <strong>Você não pode alterar o status do plano.</strong>
        </v-snackbar>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarPlanos"
          :search="search"
        >
        </e-paginate>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialog" :pdf="pdf" v-on:update="carregarDadosAoAtualizarStatus" />
    <ModalCarteiraInfantil
      :dialog="dialogInfantil"
      :pdf="pdfInfantil"
      v-on:update="carregarDadosAoAtualizarStatus"
    />
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";
import ModalCarteiraInfantil from "@/components/Matriculas/EModalCarteiraInfantil.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ModalCarteira,
    ModalCarteiraInfantil,
  },
  watch: {
    async professor(value) {
      value = this.formatarCPf(value);
      this.professor = value;
      await this.carregarPlanos();
    },
    async turma(value) {
      this.turma = value;
      await this.carregarPlanos();
    },
    async disciplina(value) {
      this.disciplina = value;
      await this.carregarPlanos();
    },
    async mes(value) {
      this.mes = value;
      await this.carregarPlanos();
    },
    async bimestre(value) {
      this.bimestre = value;
      await this.carregarPlanos();
    },
  },
  data() {
    return {
      carregando: false,
      dialog: false,
      pdf: null,
      disciplinas: [],
      turmas: [],
      planos: [],
      bimestres: [],
      bimestre: "",
      professor: "",
      turma: "",
      disciplina: "",
      mes: "",
      periodo: "",
      mostrarMensagem: false,
      dataTableFilter,
      search: "",
      pageNumber: 1,
      paginate: {
        current_page: 1,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Professor", value: "gestao_de_aula.professor.nome" },
          { text: "Turma", value: "gestao_de_aula.turma.descricao" },
          { text: "Status", value: "status" },
          { text: "Bimestre", value: "descricao" },
          { text: "Componente Curricular", value: "gestao_de_aula.disciplina.descricao" },
          {
            text: "Ações",
            value: "actions",
            sortable: false,
          },
        ],
      },
      dialogInfantil: false,
      pdfInfantil: null,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
  async mounted() {
    await this.carregarDados();
    this.permitirRolesParaGestores();
  },
  methods: {
    async carregarDados() {
      await this.carregarPlanos(this.pageNumber);
      await this.listarDisciplinas();
      await this.listarTurmas();
      await this.listarBimestres();
    },
    permitirRolesParaGestores() {
      try {
        // const userLocal = this.user?.role ? this.user.role.name : [];
        // return this.$constants.rolesParaGestores.findIndex((elem) => {
        //   return elem.name === userLocal;
        // });
        const userLocal = this.user.roles ? this.user.roleName : [];
        return this.$constants.rolesParaGestores.findIndex((elem) => {
          return elem.name === userLocal;
        });
      } catch (error) {
        this.$handleError(error);
      }
      return false;
    },
    async listarDisciplinas() {
      try {
        const { data } = await this.$services.planosService.disciplinas();
        this.disciplinas = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarTurmas() {
      try {
        const { data } = await this.$services.planosService.turmasInfantil();
        this.turmas = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async listarBimestres() {
      try {
        const { data } = await this.$services.planosService.bimestresInfantil();
        this.bimestres = data;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarPlanos(numeroDaPagina = null) {
      try {
        this.dialog = false;
        this.carregando = true;
        const pagina = numeroDaPagina || this.pageNumber;
        const payload = await this.$services.planosService.indexInfantil(
          pagina,
          this.professor,
          this.turma,
          this.disciplina,
          this.bimestre
        );

        this.planos = payload.data;
        this.paginate = payload;
        this.carregando = false;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        this.carregarPlanos();
      } catch (error) {
        this.$handleError(error);
      }
    },
    limparCampos() {
      this.professor = "";
      this.turma = "";
      this.disciplina = "";
      this.bimestre = "";
    },
    formatarCPf(value) {
      value = value.replace("-", "");
      value = value.replace(".", "");
      return value;
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfInfantil(planoId);
    },
    async mensagem(e) {
      if (!e) {
        this.mostrarMensagem = true;
      }
    },
    async visualizarPlanoAnexado(planoId) {
      try {
        const response = await this.$services.planosBimestraisInfantilService.planoAnexado(planoId);
        this.pdfInfantil = response;
        this.dialogInfantil = true;
      } catch (error) {
        const mensagem = error.message || "Nenhum arquivo PDF anexado a este plano.";
        this.$toast.danger(mensagem);
      }
    },
  },
};
</script>
<style scoped>
@media (max-width: 600px) {
  .v-card__text div {
    padding: 6px 0;
    font-size: 0.875rem;
  }

  .v-btn {
    min-width: 36px !important;
    height: 36px !important;
  }

  strong {
    min-width: 100px;
    display: inline-block;
  }

  .v-data-table {
    overflow-x: auto;
    display: block;
    font-size: 0.8rem;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .v-data-table td,
  .v-data-table th {
    padding: 0 8px !important;
  }
}
</style>
